/**
 * Game Status / Phase System
 *
 * Controls CTA behavior across the entire site.
 * Change `currentPhase` to update all CTAs at once.
 */

export type GamePhase =
    | "pre-alpha"
    | "demo-announced"
    | "demo-live"
    | "early-access"
    | "release";

export const currentPhase: GamePhase = "pre-alpha";

export interface CTAConfig {
    primary: { label: string; href: string; external: boolean };
    secondary: { label: string; href: string; external: boolean } | null;
    tertiary?: { label: string; href: string; external: boolean } | null;
}

/**
 * CTA configuration per game phase.
 * Update labels/URLs here - the rest of the site reads from this.
 */
export function getCTAConfig(
    phase: GamePhase,
    steamUrl: string
): CTAConfig {
    switch (phase) {
        case "pre-alpha":
            return {
                primary: {
                    label: "Wishlist on Steam",
                    href: steamUrl,
                    external: true,
                },
                secondary: { label: "Join the Newsletter", href: "#newsletter", external: false },
                tertiary: { label: "Explore the Mission", href: "#mission", external: false },
            };
        case "demo-announced":
            return {
                primary: {
                    label: "Wishlist on Steam",
                    href: steamUrl,
                    external: true,
                },
                secondary: { label: "Demo Coming Soon", href: "#newsletter", external: false },
                tertiary: null,
            };
        case "demo-live":
            return {
                primary: {
                    label: "Try the Demo",
                    href: steamUrl,
                    external: true,
                },
                secondary: {
                    label: "Wishlist Full Game",
                    href: steamUrl,
                    external: true,
                },
                tertiary: null,
            };
        case "early-access":
            return {
                primary: {
                    label: "Buy on Steam - Early Access",
                    href: steamUrl,
                    external: true,
                },
                secondary: { label: "Join the Newsletter", href: "#newsletter", external: false },
                tertiary: null,
            };
        case "release":
            return {
                primary: {
                    label: "Buy on Steam",
                    href: steamUrl,
                    external: true,
                },
                secondary: null,
                tertiary: null,
            };
    }
}
